import { Href, router } from 'expo-router';
import { Linking } from 'react-native';
import { isWeb } from 'shared/constants/platform';
import { Support } from 'shared/constants/support';
import { logError } from 'shared/utils/sentry/sentry';
import { showZendeskArticle } from 'shared/utils/zendesk/zendeskUtils';

export const formatChatHTMLMessage = (html: string): string =>
  html.replace(/(<a\b[^>]*>)\s*Source\s*(<\/a>)/gi, '$1Learn more$2');

export const getHyperlinkAction = async (href: string) => {
  /* For web */
  if (isWeb) {
    return router.push(href as Href);
  }
  /* 
    For Deeplinks 
    emit the url which will be handled by the deeplink provider
    */
  if (href?.includes('bank.varomoney.com')) {
    return Linking.emit('url', { url: href });
  }

  /* For Zendesk support link - open in browser tab */
  if (href?.includes(Support.SUPPORT_TICKET_LINK)) {
    if (isWeb) {
      return router.push(href as Href);
    }
    try {
      const supported = await Linking.canOpenURL(href);
      if (supported) {
        await Linking.openURL(href);
      }
    } catch (error) {
      logError(error);
    }
  }
  /* Zendesk article */
  if (href?.includes(Support.SUPPORT_LINK)) {
    try {
      const num = href.match(/(\d+)/g);
      if (num?.length) {
        return showZendeskArticle(Number(num[0]));
      }
    } catch (error) {
      logError(error);
    }
  }
  try {
    /* Fallback logic - open in browser tab */
    const supported = await Linking.canOpenURL(href);
    if (supported) {
      await Linking.openURL(href);
    }
  } catch (error) {
    logError(error);
  }
};
